import React, {useState} from 'react';
import {Button, Dialog, DialogContent, DialogTitle, Box, TextField} from "@mui/material";
import IconButton from "@mui/material/IconButton";

function TodoDialogEditNotes({ isOpen, onClose, eventTodo, setEventTodo }) {

    const [ _notes, setNotes] = useState(eventTodo.notes);

    function saveTodoItemNotes() {
        // Corrected syntax: added parentheses around the object
        setEventTodo((prev) => ({
            ...prev,
            notes: _notes
        }));
        onClose(); // Don't forget to close the dialog after saving!
    }


    return (

        <Dialog open={isOpen} onClose={onClose} PaperProps={{
            sx: {
                minWidth: 350, // or '350px'
                maxWidth: 500, // optional
                width: '100%', // allows it to scale on smaller screens
            },
        }}>
            {/* Dialog Title */}
            <DialogTitle
                sx={{
                    color: '#151269',
                    textAlign: 'center',
                    backgroundColor: 'rgba(198, 226, 255, 0.8)',
                    paddingRight: '30px'
                }}
            >
                To-Do Item Notes
            </DialogTitle>
            {/* Close Button */}
            <IconButton
                aria-label="close"
                onClick={onClose}
                sx={{
                    position: 'absolute',
                    right: 8,
                    top: 8,
                    color: '#151269',
                }}
            >
                <i className="icon-cross" style={{ fontSize: '18px', padding: '5px' }} />
            </IconButton>

            {/* Dialog Content */}
            <DialogContent sx={{ pt: 2 }}>
                <TextField
                    fullWidth
                    label="Notes"
                    value={_notes}
                    onChange={(e) => setNotes(e.target.value)}
                    variant="outlined"
                    margin="dense"
                />
                <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2 }}>
                    <Button onClick={onClose} sx={{ mr: 1 }}>Cancel</Button>
                    <Button variant="contained" onClick={saveTodoItemNotes}>Save</Button>
                </Box>
            </DialogContent>

        </Dialog>
    )
}

export default TodoDialogEditNotes;